(function () {
    "use strict";


    Controllers.NewAddUserController = Class(Controllers.BaseController, {

        // need to pass all injections from child controller.
        // @ngInject
        constructor: function constructor($scope, $modalInstance, $injector, $translate, UsersManager, UserService, _,
                                          CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService,
                                          SearchablesManager, ValidationsManager) {

            Controllers.NewAddUserController.$super.call(this, $scope, $injector);
            this.__objectType = 'NewAddUserController';
            this.$injector = $injector;
            this.UsersManager = UsersManager;
            this.UserService = UserService;
            this._ = _;
            this.$translate = $translate;
            this.$modalInstance = $modalInstance;
            this.ModelFactory = ModelFactory;
            this.GoogleAPIService = GoogleAPIService;
            this.AnalyticsService = AnalyticsService;
            this.SearchablesManager = SearchablesManager;
            this.ValidationsManager = ValidationsManager;
            this.fetchedUserFromDb = false;

            if ($injector) {
                this.DeviceService = $injector.get("DeviceService");
                this.HelpService = $injector.get("HelpService");
                this.Drift = $injector.get('Drift');
                this.DriftService = $injector.get('DriftService');
                this.ContactsManager = $injector.get('ContactsManager');
            }

            if (this.DeviceService) {
                this.isMobile = this.DeviceService.nxSmallBreakpoint();
            } else {
                this.isMobile = false;
            }

            this.shouldShowCompanyTypeDropdown = false;
            this.shouldShowBusinessInfoOnBottom = false;

            if (ModelFactory) {
                this.user = ModelFactory.newUserModel();
                this.user.system_user_type = 'client';
            }
            if (CompanyService) {
                this.companyTypes = CompanyService.getCompanyTypesEnum();
                this.companyTypesValues = this.companyTypes.map(function (companyType) {
                    return $translate.instant(companyType.text);
                });
            }

            if (NetworkManager) {
                this.NetworkManager = NetworkManager;
            }

            if ($scope) {
                $scope.$watch('addUserVm.user.email', function(newVal, oldVal) {
                    if (newVal !== undefined && oldVal !== newVal) {
                        this.onEmailChange();
                    }
                }.bind(this));

                $scope.$on('$destroy', function () {
                    this._onCloseModal();
                }.bind(this));
            }

            this.NOTES_SETTINGS = {
                MAX_LENGTH: 500,
                MAX_NEGATIVE_CHARS: 100,
                CHANGE_STYLE_AFTER_CHARS: 450,
                MIN_CHARS_TO_SHOW_COUNTER: 300
            };

            this.showErrorMessage = false;

            if ($translate) { //set default. override when inherit.
                this.titleText = $translate.instant("ADD_USER_DIALOG.NEW_ADD_USER_MODAL._TITLE_");
                this.subTitleText = $translate.instant("ADD_USER_DIALOG.NEW_ADD_USER_MODAL._SUBTITLE_");
                this.ctaText = $translate.instant("ADD_USER_DIALOG.NEW_ADD_USER_MODAL._SAVE_");
            }

            this.isVendor = false;
            this.isVendorEditDisabled = false;
            this.showOptionalFields = true;
            this.isDisplayAvatar = false; //override for edit -display the avatar only in edit.
            this.isSuggestFromGmailContacts = false;
            this.isSuggestFromDirectory = false;
            this.isSuggestFromContacts = false;
            this.fetchUserFromContacts = true;
            this.suggestedContacts = [];

            this.showDropdown = false;

            if (this.isMobile && this.HelpService) {
                this.HelpService.hideHelp();
            }
            if (this.isMobile && this.Drift) {
                this.Drift.hide();
            }
        },

        _onCloseModal: function() {
            if (this.isMobile && this.HelpService) {
                this.HelpService.restoreDefaultVisibility();
            }
            if (this.isMobile && this.DriftService) {
                this.DriftService.restoreDefaultVisibility();
            }
        },

        shouldShowWillInviteFooter: function () {
            return false;
        },

        onUserTypeChanged: function() {
          this.isVendor = this.user.isVendor();
          this.afterIsVendorChanged();
        },

        afterIsVendorChanged: function() {
            //to be overridden. we used to change the cta text here for example, in the current design it is the same.
        },

        onEmailChange: function() { //override this for edit mode. we don't want to reset the user._id. and we don't want to display drop down.
          //custom error will usually be server side error, so need to reset it.
            this.customEmailErrorMessage = "";
            this.addUserForm.email.$setValidity("customError", true); // set it to valid.

            this.getUserFromDb();

        },

        getUserFromDb: function() {
            var dbUser = this.ModelFactory.newUserModel();

            this._fetchUserFromDb(this.user, dbUser).then(function() {
                this.handleUserFromDb(dbUser);
                if (!dbUser.email && this.user.email) {
                    this.validateEmailAddress(this.user.email);
                }
                else{
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.add_user_dialog_found_user_by_email, {user_email: dbUser.email});
                }
            }.bind(this));
        },

        validateEmailAddress: function(email) {
            this.ValidationsManager.validateEmail(email).then(function() {
               this.hideEmailWarning();
            }.bind(this), function(resp) {
                if(resp.data && resp.data.error_message === "Invalid Email Address") {
                    this.showEmailWarning(email);
                } else if(userModel.__warnInvalidEmail) {
                    this.hideEmailWarning();
                }
            }.bind(this));
        },

        onEmailTextChange: function() {
            this.hideEmailWarning();
            this.submitError = null;
            this.searchSuggestions(this.addUserForm.email.$viewValue);
        },

        onEmailTabKeyClicked: function() {
           this.hideDropdown();
        },

        handleUserFromDb: function(dbUser){ //override this for add connection, should always be disabled true.
            if (dbUser.email) {
                this.fetchedUserFromDb = true;
                this.isVendorEditDisabled = true;
                this.user = dbUser;
                this.isVendor = dbUser.isVendor();
                this.afterIsVendorChanged();
            } else { //user doesn't exist
                this.isVendorEditDisabled = false;
                // clean the whole user object if we already fetched an existing user from database
                if (this.fetchedUserFromDb) {
                    var email = this.user.email;
                    this.user = this.ModelFactory.newUserModel();
                    this.user.system_user_type = 'client';
                    this.user.email = email;
                    this.fetchedUserFromDb = false;
                    this.isVendor = false;
                }
                else {
                    this.user._id = null; // keep old code before HON-9372 fix
                }


            }
        },

        onSaveClick: function(e, form) {
            e.preventDefault();
            this.addUserForm.$setSubmitted();

            if (!form.$valid) {
                this.showErrorMessage = true;
                return;
            }
            this.isSaving = true;
            this.saveUser()
                .then(function(resp) {
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.add_user_dialog_save_user_success);
                        this.$modalInstance.close(resp);
                    }.bind(this),
                    function(resp) {
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.add_user_dialog_save_user_error, resp.data.error_message);
                        this.submitError = resp.data.error_message;
                    }.bind(this))
                .finally(function() {
                    this.isSaving = false;
                }.bind(this));
        },

        dismiss: function() {
            this.$modalInstance.dismiss();
            this._onCloseModal();
        },

        saveUser: function(){
            throw "unimplemented";
        },

        close: function(resp) {
            this.$modalInstance.close(resp);
            this._onCloseModal();
        },

        showTypeahead: function() {
            angular.element('.js-typeahead-dropdown-control + .f-dropdown').removeClass('hidden');
        },

        onCompanyTypeChanged: function($item) {

            var selectedCompanyTypeName = $item || this.user.company.company_type_name;

            var selectedCompanyType = this._.find(this.companyTypes, function (companyType) {
                return this.$translate.instant(companyType.text) === selectedCompanyTypeName;
            }.bind(this));

            if (selectedCompanyType) {
                this.user.company.company_type = selectedCompanyType.key;
                angular.element('.js-typeahead-dropdown-control + .f-dropdown').addClass('hidden');
            } else if (selectedCompanyTypeName) {
                this.user.company.company_type = "other";
                this.user.company.company_other = selectedCompanyTypeName;
            } else {
                this.user.company.company_type = null;
                this.user.company.company_other = null;
            }
        },

        searchSuggestions: function(searchText) {

            if (!searchText) {
                this.showDropdown = false;
                return; 
            }

            if ( searchText.length < 3) {
                this.showDropdown = false;
                this.clearSuggestions();
                return;
            }

            if (this.isSuggestFromGmailContacts) { this.getGmailContacts(searchText); }
            if (this.isSuggestFromDirectory)     { this.getDirectoryContacts(searchText); }
            if (this.isSuggestFromContacts) {this.searchContacts(searchText); }
            if (this.isSuggestFromVendorContacts) {this.searchVendorContacts(searchText); }

            this.showDropdown = true;
        },

        getGmailContacts: function(searchText) {
            this.getContactsToView( searchText);
        },

        onSearchItemClick: function(selectedUser){
            this._copySearchResultToUser(selectedUser);

            //do we need to pass the avatar here?
            this.showDropdown = false;
            this.onEmailChange();
        },

        onGoogleSearchItemClick: function(selectedContact) {
            this._copySearchResultToUser(selectedContact);

            //do we need to pass the avatar here?
            this.showDropdown = false;
            this.onEmailChange();

        },

        _copySearchResultToUser: function _copySearchResultToUser(selectedResult) {
            this.user._id = selectedResult.user_id;
            this.user.email = selectedResult.email;
            this.user.full_name = selectedResult.full_name;
            this.user.phone_number = selectedResult.phone_number;
            this.user.address = selectedResult.address;

            this.user.company.company_type = selectedResult.company_type;
            this.user.company.company_name = selectedResult.company_name;
            this.user.company.website_url = selectedResult.website_url;

            this.user.notes = selectedResult.notes;
        },

        getDirectoryContacts: function(searchText) {
         //   this.searchData = this.SearchablesManager.search(searchText, "contacts" ,{searchCommunity: "true"}); //todo - search community only when need to.
            this.searchData = this.ModelFactory.newNetworkUsersCollection();
            this.NetworkManager.listNetworkUsers(null, null, null, null, searchText, 30, this.searchData).then(function(res){
               // console.log('searchData is', this.searchData);
            }.bind(this));
        },

        searchContacts: function(searchText) {
            this.searchData = this.SearchablesManager.search(searchText, "contacts");
        },

        searchVendorContacts: function(searchText) {
            this.searchData = this.SearchablesManager.search(searchText, "vendorContacts");
        },

        connectGoogleContacts: function() {
            var self = this;

            this.GoogleAPIService.getContactsAPI(this.suggestedContacts, true).then(function(contactsAPI) {
                this.AnalyticsService.track(self, self.AnalyticsService.analytics_events.connect_to_google_successful);

                this.getContactsToView(this.addUserForm.email.$viewValue );
            }.bind(this), function(err) {

                // Check if user pressed cancel
                if (err === 'access_denied') {
                    self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.connect_to_google_unsuccessful);
                } else {
                    self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.connect_to_google_canceled);
                }
            });
        },

        connectGoogleOptionShown: function() {
           this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.connect_to_google_option_show);
        },

        clearSuggestions: function(){
            this.suggestedContacts = [];
            this.searchData = [];
            this.showConnectToGoogle = false;
        },

        getContactsToView: function(search) {
            var self = this;
            var apiToCall = this.GoogleAPIService.searchContactsAPI;

            if (search === undefined) {
                search = null;
            }

            apiToCall.call(this.GoogleAPIService, [], false, search).then(function(contactsAPI) {
                self.isLoadingContacts = true;
                self.showConnectToGoogle = false;
                self.contactsAPI = contactsAPI;
                self.getContacts(30, false);
            }, function() {
                self.showConnectToGoogle = true;
            });
        },

        getContacts: function(num, isFirstTime) {
            var self = this;

            if (isFirstTime == null) {
                isFirstTime = false;
            }

            this.contactsAPI.getNextContacts(num, isFirstTime).then(function(response) {

                if (self.isLoadingContacts) {
                    self.isLoadingContacts = false;
                }

                self.suggestedContacts = response.contacts;

            },function(xhr) {
                return self.handleXHRError(xhr);
            });
        },

        showEmailWarning: function(email) {
            this.emailInvalidWarning = "* The email " + email + " seems to be invalid";
        },

        hideEmailWarning: function(){
            this.emailInvalidWarning = null;
        },

        hideDropdown: function() {
            this.showDropdown = false;
        },

        getNotesCounter: function() {
            var counter = '';
            if (this.user.notes && (this.user.notes.length >= this.NOTES_SETTINGS.MIN_CHARS_TO_SHOW_COUNTER)) {
                counter = this.NOTES_SETTINGS.MAX_LENGTH - this.user.notes.length;
            }
            return counter;
        },
        getFullNameErrorMessage: function() {
            if (this.addUserForm.fullName.$error.minlength) return this.$translate.instant('ERRORS._NAME_TOO_SHORT_');
            else if (this.addUserForm.fullName.$error.maxlength) return this.$translate.instant('ERRORS._NAME_MISSING_');
        },
        getEmailErrorMessage: function() {
            var invalidEmailString = this.$translate.instant('ERRORS._INVALID_EMAIL_ADDRESS_');
            
            if (this.addUserForm.email.$error.email) {
                return invalidEmailString;
            } else if (!this.addUserForm.email.$error.email && this.addUserForm.email.$error.pattern) {
                return invalidEmailString;
            } else if (this.addUserForm.email.$error.required) {
                return invalidEmailString;
            } else if (this.addUserForm.customEmailErrorMessage) {
                return this.addUserForm.customEmailErrorMessage;
            }
        },

        _fetchUserFromDb: function _getUserApiCall(user, dbUser) {
            var promise = null;

            if (this.fetchUserFromContacts) {
                promise = this._fetchContact(user, dbUser);
            } else {
                promise = this.UsersManager.getUserByEmail(user.email, dbUser);
            }

            return promise;
        },

        _fetchContact: function _fetchContact(user, dbUser) {
            var collection = this.ModelFactory.newContactsCollection();
            return this.ContactsManager.getUserContacts(collection, this.UsersManager.getCurrUser(), 1, {exact_email: true, text: user.email}, 1).then(function() {
                var contact = collection[0];
                if (contact) {
                    dbUser.mixinFrom(contact.user);
                }
                return dbUser;
            }.bind(this));
        },

        handleXHRError: function handleXHRError(error) {
            // do something about it?
        }
    });
}());
